import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Container, Spinner } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext';

const AuthCallback = () => {
  const { handleAuthCallback, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const errorMsg = searchParams.get('error');
    
    if (errorMsg) {
      setError(errorMsg);
      setTimeout(() => navigate('/login?error=' + errorMsg), 2000);
      return;
    }
    
    // Extract token from URL if present
    const token = searchParams.get('token');
    if (token) {
      // Pass the token to the auth context
      handleAuthCallback(token);
    } else {
      // Fall back to cookie-based auth if no token
      handleAuthCallback();
    }
  }, [searchParams, handleAuthCallback, navigate]);
  
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  return (
    <Container className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      {error ? (
        <div className="text-center">
          <h2 className="text-danger mb-4">Authentication Error</h2>
          <p>{error}</p>
          <p>Redirecting to login...</p>
        </div>
      ) : (
        <div className="text-center">
          <h2 className="mb-4">Authenticating...</h2>
          <Spinner animation="border" role="status" variant="primary" style={{ width: '3rem', height: '3rem' }}>
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}
    </Container>
  );
};

export default AuthCallback;
